import Vue from 'vue'

import { bb } from 'billboard.js'

import 'billboard.js/dist/billboard.css'

Vue.prototype.$bb = bb
